//From https://github.com/bboyle/quick-exit

/*Copyright (c) 2016, Queensland Government.
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of Queensland Government nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.*/

(function (window) {
    //console.log("working");
    "use strict";

    var history = window.history;
    var exitElement;
    var accesskeyLinks = {};

    function quickExit(event, target) {
        target = target || event.target;
        var href = target.href;

        window.document.body.style.opacity = 0;
        window.document.title = "New Tab";
        // clears current frame only
        while (document.firstChild) {
            document.removeChild(document.firstChild);
        }

        if (history && history.replaceState) {
            history.replaceState({}, "", "/");
        }

        // href = this.href || target.href;
        while (!href && target !== exitElement && target.parentNode) {
            target = target.parentNode;
            href = target.href;
        }

        href =
            href || target.getElementsByTagName("a")[0].href || "about:blank";

        /* jshint -W040 */
        window.location = href;
        /* jshint +W040 */

        event.preventDefault();
        return false;
    }

    function quickExitKeyboard(event) {
        if (accesskeyLinks[event.keyCode]) {
            if (
                /^(INPUT|TEXTAREA|SELECT|BUTTON)$/i.test(event.target.tagName)
            ) {
                return;
            }
            quickExit.call(event.target, event, accesskeyLinks[event.keyCode]);
        }
    }

    function setupEventHandlers(addEventListener) {
        var i;
        var accesskey, link;

        function getAccesskey(element) {
            var KEYS = {
                esc: 27,
            };
            var accesskey =
                element.getAttribute("data-accesskey") ||
                element.getAttribute("accesskey");

            if (/^[a-zA-Z]$/.test(accesskey)) {
                return accesskey.toUpperCase().charCodeAt(0);
            } else if (accesskey) {
                return KEYS[accesskey.toLowerCase()];
            }

            return null;
        }

        link = exitElement.getElementsByTagName("a");
        for (i = 0; i < link.length; i++) {
            accesskey = getAccesskey(link[i]);

            if (accesskey) {
                accesskeyLinks[accesskey] = link[i];
            }
        }

        exitElement[addEventListener]("click", quickExit, true);
        if (Object.keys(accesskeyLinks).length) {
            document[addEventListener]("keydown", quickExitKeyboard, true);
        }
    }

    function init() {
        var addEventListener = document.addEventListener
            ? "addEventListener"
            : "attachEvent";

        if (exitElement) {
            return; // aleady setup
        }

        exitElement = document.getElementById("quick-exit");

        if (exitElement) {
            // setup now
            setupEventHandlers(addEventListener);
        } else {
            // setup on ready/load
            document[addEventListener]("DOMContentLoaded", init);
            document[addEventListener]("load", init);
        }
    }

    init();
})(window.top);
